/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
import { NgModule } from '@angular/core';
import { DataPersistence } from './data-persistence';
/**
 * \@whatItDoes Provides services for enterprise Angular applications.
 *
 * See {\@link DataPersistence} for more information.
 */
import * as ɵngcc0 from '@angular/core';
export class NxModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return { ngModule: NxModule, providers: [DataPersistence] };
    }
}
NxModule.ɵfac = function NxModule_Factory(t) { return new (t || NxModule)(); };
NxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NxModule });
NxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NxModule, [{
        type: NgModule,
        args: [{}]
    }], null, null); })();

